/**
 * Scrap-type tags. The slug is what gets stored. Labels must stay in sync
 * with `scrap_tag_label` in supabase/migrations/121_scrap_log.sql.
 */
export const SCRAP_TAGS: Array<{ value: string; label: string; hint: string }> = [
  { value: 'cosmetic', label: 'Cosmetic', hint: 'Scratch, scuff, color, finish' },
  { value: 'dimensional', label: 'Out of spec', hint: "Won't fit, wrong size, warped" },
  { value: 'assembly', label: 'Assembly error', hint: 'Wrong part, missed step, backwards' },
  { value: 'material', label: 'Bad material', hint: 'Crack, void, short shot, contamination' },
  { value: 'tooling', label: 'Tool / machine', hint: 'Broken bit, worn fixture, machine fault' },
  { value: 'process', label: 'Process', hint: 'Wrong torque, cure, temp, or setting' },
  { value: 'damage', label: 'Handling damage', hint: 'Dropped, crushed, or scratched after the build' },
  { value: 'missing', label: 'Missing / incomplete', hint: 'Part never installed or lost' },
  { value: 'other', label: 'Other', hint: 'Does not fit the tags above' },
];

const LABEL_BY_SLUG = new Map(SCRAP_TAGS.map((t) => [t.value, t.label]));

export function slugifyScrapTag(raw: string): string {
  return raw
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 40);
}

export function scrapTagLabel(slug: string | null | undefined): string {
  if (!slug) return 'Untagged';
  return LABEL_BY_SLUG.get(slug) ?? slug.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
